export default __webpack_public_path__ + "static/media/eb-ultra-wht-poster-2.87640ce4.jpg";